
import React, { useState } from 'react'
import classes from './File.module.css';
import { useHistory } from "react-router";

const File = props => {

    return (
    <section id="portfolio">
        <div className="row">
        <div className="twelve columns collapsed">
          <div>
            <a href=".." className="file-back">Back</a>
            <div className={classes.FileBoxWrapper}>
              <div className={classes.FileBox}>{props.content}</div>
            </div>
          </div>
        </div>

        </div>
    </section>


    )
}


export default File
